// import { useRef, useState, useEffect } from "react"
import { connect } from "react-redux"

import { EntityInput } from "../Entity/EntityInput";

import "styles/components/popup.sass"

export const CLIENT_SIGNATURE_KEY = "client_signature"


let UserSignature: any = function UserSignature(inputState: any) {
    const [value, setValue] = inputState.inputState;
    return <EntityInput
        entity={{value, type: "Фото", addWatermark: false}}
        updateEntity={(value: string) => {
            setValue(value)
        }}
        setImageStringTag={false}
        maxImageWidth="120px"
    />
}

UserSignature = connect(
    (store) => ({ $store: store }),
    (dispatch) => ({
      $commitToStore: (data: any) => dispatch({ ...data, type: 'S' })
    })
)(UserSignature)

export default UserSignature

